export const DAMAGE_DURING_ROUTE_STEPS = [
  'damage_during_route.injured',
  'damage_during_route.damage_location',
  'damage_during_route.summary_title',
]

export const MAX_UPLOAD_COUNT = 3
export const MIN_UPLOAD_COUNT = 1
